import React from 'react';
import { useTranslation } from 'react-i18next';
import { differenceInDays } from 'date-fns';
import RadialChartCard from '../../../../charts/RadialChartCard';
import { ChartCardType, ReportDateRange } from '../../../../types';
import { resolveDateRange } from '../../../../utils/report-date-utils';

interface ActiveDaysChartProps {
  activeDayCount: number;
  dateRange: ReportDateRange;
  loading: boolean;
}

const getDateRangeInDays = (dateRange: ReportDateRange): number => {
  const { dateStart, dateEnd } = resolveDateRange(dateRange);
  return differenceInDays(dateEnd, dateStart);
};

const ActiveDaysChart: React.FC<ActiveDaysChartProps> = ({
  activeDayCount,
  dateRange,
  loading
}): React.ReactElement => {
  const { t } = useTranslation(['Reports', 'ReportsHelpCharts']);

  return (
    <RadialChartCard
      title={t('No. of Active Days')}
      helpText={t('activeDays', { ns: 'ReportsHelpCharts' })}
      type={ChartCardType.COUNT}
      total={getDateRangeInDays(dateRange)}
      progress={activeDayCount}
      color="#006db8"
      loading={loading}
    />
  );
};

export default React.memo(ActiveDaysChart);
